// import { useState } from "react";
// import { VscSignOut } from "react-icons/vsc";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

// import { sidebarLinks } from "../../../data/dashboard-links";
// import { logout } from "../../../services/operations/authAPI";
// import ConfirmationModal from "../../common/ConfirmationModal";
// import SidebarLink from "./SidebarLink";
// import "./Sidebar.css";

// export default function Sidebar() {
//   const { user, loading: profileLoading } = useSelector(
//     (state) => state.profile
//   );
//   const { loading: authLoading } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [confirmationModal, setConfirmationModal] = useState(null);

//   if (profileLoading || authLoading) {
//     return (
//       <div className="sidebar-loading">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div className="sidebar-container">
//         {/* Top links */}
//         <div className="sidebar-links">
//           {sidebarLinks.map((link) => {
//             if (link.type && user?.accountType !== link.type) return null;
//             return (
//               <SidebarLink key={link.id} link={link} iconName={link.icon} />
//             );
//           })}
//         </div>

//         {/* Bottom settings + logout */}
//         <div className="sidebar-settings">
//           <SidebarLink
//             link={{ name: "Settings", path: "/dashboard/settings" }}
//             iconName="VscSettingsGear"
//           />

//           <button
//             onClick={() =>
//               setConfirmationModal({
//                 text1: "Are you sure?",
//                 text2: "You will be logged out of your account.",
//                 btn1Text: "Logout",
//                 btn2Text: "Cancel",
//                 btn1Handler: () => dispatch(logout(navigate)),
//                 btn2Handler: () => setConfirmationModal(null),
//               })
//             }
//             className="sidebar-link sidebar-logout-button"
//           >
//             <span className="sidebar-highlight" />
//             <div className="sidebar-link-content">
//               <VscSignOut className="sidebar-icon" />
//               <span className="sidebar-link-text">Logout</span>
//             </div>
//           </button>
//         </div>
//       </div>

//       {confirmationModal && (
//         <ConfirmationModal modalData={confirmationModal} />
//       )}
//     </>
//   );
// }


import { useState } from "react";
import { VscSignOut } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { sidebarLinks } from "../../../data/dashboard-links";
import { logout } from "../../../services/operations/authAPI";
import ConfirmationModal from "../../common/ConfirmationModal";
import SidebarLink from "./SidebarLink";
import "./Sidebar.css";

export default function Sidebar() {
  const { user, loading: profileLoading } = useSelector(
    (state) => state.profile
  );
  const { loading: authLoading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [confirmationModal, setConfirmationModal] = useState(null);

  if (profileLoading || authLoading) {
    return (
      <div className="sidebar-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <div className="sidebar-container">
        {/* Top links */}
        <div className="sidebar-links">
          {sidebarLinks.map((link) => {
            if (link.type && user?.accountType !== link.type) return null;
            return (
              <SidebarLink key={link.id} link={link} iconName={link.icon} />
            );
          })}
        </div>

        {/* Bottom settings + logout */}
        <div className="sidebar-settings">
          <SidebarLink
            link={{ name: "Settings", path: "/dashboard/settings" }}
            iconName="VscSettingsGear"
          />

          <button
            onClick={() =>
              setConfirmationModal({
                text1: "Are you sure?",
                text2: "You will be logged out of your account.",
                btn1Text: "Logout",
                btn2Text: "Cancel",
                btn1Handler: () => dispatch(logout(navigate)),
                btn2Handler: () => setConfirmationModal(null),
              })
            }
            className="sidebar-link sidebar-logout-button"
          >
            <span className="sidebar-highlight" />
            <div className="sidebar-link-content">
              <VscSignOut className="sidebar-icon" />
              <span className="sidebar-link-text">Logout</span>
            </div>
          </button>
        </div>
      </div>

      {confirmationModal && (
        <ConfirmationModal modalData={confirmationModal} />
      )}
    </>
  );
}
